import * as React from 'react'
import MenuMUI from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { MenuProps } from './MenuTypes'

export default function Menu({ MenuProps, items }: MenuProps): JSX.Element {
  return (
    <MenuMUI {...MenuProps}>
      {items.map((itemProps) => {
        return <MenuItem key={itemProps.key} {...itemProps} />
      })}
    </MenuMUI>
  )
}
